/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React from 'react';
// useState
import { Alert } from 'antd';

const Header = block => {
  const { validation } = block;
  // const validation = {
  //   fldName: 'wosb',
  //   msgLvl: 1,
  //   msgNbr: 7,
  //   msgTxt:
  //     'The Woman-Owned Small Business or Economically Disadvantaged Woman Owned Small Business (EDWOSB) you have selected does not match the Woman-Owned Small Business or Economically Disadvantaged Woman Owned Small Business (EDWOSB)  in your Sam.gov registration.',
  //   nsnOrPn: '',
  //   solLnNum: 0,
  //   validationTime: '2021-05-17 21:05:21 UTC',
  // };

  return (
    <div>
      {' '}
      <Alert
        description={validation.msgTxt}
        showIcon
        type={validation.msgLvl === 1 ? 'warning' : 'error'}
      />
      <br />
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/reviewComponents/errors.jsx